import { render } from "./github.svg?vue&type=template&id=7e308b12"
const script = {}
script.render = render

export default script